import { ValueAddedServiceCode } from '~/apiClient';

const vasOrder: ValueAddedServiceCode[] = [
    ValueAddedServiceCode.FleequidCare,
    ValueAddedServiceCode.PowertrainWarranty,
    ValueAddedServiceCode.LogisticsService,
    ValueAddedServiceCode.ProvisionalLicensePlate,
    ValueAddedServiceCode.VehicleNationalization,
    ValueAddedServiceCode.VehicleRegistration,
] as const;

export function sortVasList<T extends { valueAddedServiceCode: ValueAddedServiceCode }>(vasList: T[]): T[];

export function sortVasList<T extends { valueAddedServiceCode: ValueAddedServiceCode }>(vasList?: T[]): T[] | undefined;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function sortVasList<T extends { valueAddedServiceCode: ValueAddedServiceCode }>(vasList?: T[]) {
    return vasList?.toSorted((a, b) => {
        const indexA = vasOrder.indexOf(a.valueAddedServiceCode);
        const indexB = vasOrder.indexOf(b.valueAddedServiceCode);

        // Treat not found items as Infinity to place them last.
        const orderA = indexA === -1 ? Infinity : indexA;
        const orderB = indexB === -1 ? Infinity : indexB;

        return orderA - orderB;
    });
}
